module.exports = __webpack_public_path__ + "static/media/xls.cea94f0d.svg";